/**
 * desc 可自定义表格展示列
 * @param notSupportList?: 不支持切换展示的dataIndex[]
 * @param selected?: 展示的dataIndex[]，默认展示全部
 * @param title?: 标题
 * @param hasExport?: 是否需要导出按钮
 * @param tableProps: 表格Props
 * @param tableDataTotalNum: 表格数据总数
 * @param exportObj？: 导出配置
 * @param onChange? 展示项改变回调
 *    @param type: 所属模块
 *    @param params: {} 导出所需参数
 *    @param fileName: string 导出文件名
 *    @param allow: string 所需权限
 *
 * */
import { __rest } from "tslib";
import React, { Component } from 'react';
import { Dropdown, Menu, Table, Checkbox, Button, Icon, message } from 'antd';
import { judgeObj } from '@/shared/functions';
import styles from './_style/index.less';
import { dispatch } from '@@/store';
import Authorized from '@/components/Auth/auth';
class TableCustomShow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showChange: false,
            tableCheckCloums: [],
            selectedList: [],
        };
    }
    dealCanCustomData() {
        const { tableCheckCloums } = this.state;
        const { notSupportList = [] } = this.props;
        let canSelectedList = tableCheckCloums;
        if (notSupportList.length > 0) {
            canSelectedList = tableCheckCloums.filter((item) => {
                return notSupportList.findIndex((can) => can === item.dataIndex) === -1;
            });
        }
        return canSelectedList;
    }
    dealSelect() {
        const list = this.dealCanCustomData();
        return (<Menu>
        {list.map((item) => (<Menu.Item key={`menu-${item.dataIndex}`}>
              <div className={'circle-checkbox'}>
                <Checkbox checked={item.checked} onChange={(e) => {
            this.changeShow({
                checked: e.target.checked,
                val: item.dataIndex,
            });
        }}>
                  {item.title}
                </Checkbox>
              </div>
            </Menu.Item>))}
      </Menu>);
    }
    dealColums() {
        const { selected = [], tableProps, notSupportList = [] } = this.props;
        console.log('reRender', selected);
        const { columns } = tableProps;
        if (columns) {
            const deal = columns.map((v) => {
                let checked = true;
                if (selected.length > 0) {
                    checked = selected.findIndex((i) => i === v.dataIndex) !== -1;
                }
                if (notSupportList.length > 0) {
                    checked = (notSupportList.findIndex((i) => i === v.dataIndex) !== -1) ? true : checked;
                }
                return Object.assign(Object.assign({}, v), { checked });
            });
            this.setState({
                tableCheckCloums: deal,
            });
        }
        selected.length > 0 && this.setState({
            selectedList: selected,
        });
    }
    changeShow({ checked, val }) {
        const { tableCheckCloums } = this.state;
        const { notSupportList = [] } = this.props;
        const checkedList = tableCheckCloums.filter((item) => item.checked);
        const index = tableCheckCloums.findIndex((item) => item.dataIndex === val);
        if (checked) {
            tableCheckCloums[index].checked = true;
        }
        else {
            if (checkedList.length - notSupportList.length - 1 === 0) {
                message.warning('请至少选择一项展示');
            }
            else {
                tableCheckCloums[index].checked = false;
            }
        }
        this.setState({
            tableCheckCloums,
        });
        if (this.props.onChange) {
            const indexList = [];
            const itemList = [];
            tableCheckCloums.forEach((item) => {
                const { checked } = item, other = __rest(item, ["checked"]);
                if (checked) {
                    if (notSupportList.findIndex((item) => item === other.dataIndex) === -1) {
                        indexList.push(other.dataIndex);
                        itemList.push(other);
                    }
                }
            });
            this.props.onChange({
                checkedIndexList: indexList,
                checkedItemList: itemList,
            });
        }
    }
    componentWillReceiveProps() {
        const { selectedList } = this.state;
        const { selected } = this.props;
        if (JSON.stringify(selectedList) !== JSON.stringify(selected)) {
            this.dealColums();
        }
    }
    componentWillMount() {
        this.dealColums();
    }
    dealScroll(scroll) {
        let changeX = 0;
        const { tableCheckCloums } = this.state;
        const checkedList = tableCheckCloums.filter((item) => item.checked);
        checkedList.forEach((v) => {
            changeX += v.width ? v.width : 100;
        });
        return { x: changeX, y: 500 };
    }
    dealFixedData() {
        const { tableCheckCloums } = this.state;
        const checkedList = tableCheckCloums.filter((item) => {
            return item.checked;
        });
        const fixedLeft = [];
        const fixedRight = [];
        const list = [];
        checkedList.forEach((v) => {
            switch (v.fixed) {
                case 'left':
                    fixedLeft.push(v);
                    break;
                case 'right':
                    fixedRight.push(v);
                    break;
                default:
                    list.push(v);
            }
        });
        list[list.length - 1] = Object.assign({}, list[list.length - 1], { width: undefined });
        return [...fixedLeft, ...list, ...fixedRight];
    }
    onExport() {
        const { exportObj } = this.props;
        if (judgeObj(exportObj)) {
            const { type, params, fileName } = exportObj;
            dispatch.global.export({
                type,
                fileName,
                params,
            });
        }
        else {
            console.warn('导出参数exportObj不合法');
        }
    }
    componentDidUpdate() {
        const { selectedList } = this.state;
        const { selected } = this.props;
        if (JSON.stringify(selectedList) !== JSON.stringify(selected)) {
            this.dealColums();
        }
    }
    render() {
        const { showChange } = this.state;
        const { title, hasExport, tableProps, tableDataTotalNum, exportObj = {}, visibleSelect } = this.props;
        const { scroll, columns } = tableProps, otherTableProps = __rest(tableProps, ["scroll", "columns"]);
        return (<React.Fragment>
        <div className={styles.customHead}>
          <div className={styles.customLeft}>
            {title && (<span className={styles.customTitle}>{title}</span>)}
            {visibleSelect && (<Dropdown visible={showChange} overlay={this.dealSelect()} onVisibleChange={(visible) => {
            this.setState({
                showChange: visible,
            });
        }}>
                  <Button style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }}>
                    <Icon type="eye" style={{ fontSize: '16px' }}/>
                    显示
                  </Button>
                </Dropdown>)}
          </div>
          {hasExport && (<Authorized allow={exportObj.allow}>
              <Button type={'primary'} onClick={() => {
            this.onExport();
        }}>
                导出excel
              </Button>
            </Authorized>)}
        </div>
        {tableDataTotalNum !== undefined && <div className={styles.totalTip}>{`共搜索到${tableDataTotalNum}条数据`}</div>}
        <Table columns={this.dealFixedData()} {...otherTableProps} scroll={this.dealScroll(scroll)}/>
      </React.Fragment>);
    }
}
TableCustomShow.defaultProps = {
    selected: [],
    hasExport: true,
    exportObj: {},
    visibleSelect: true
};
export default TableCustomShow;
